import { Signal } from "@/data/util/Signal";

import { Ripple } from "@/shared/ui/Ripple";

import { TastierClient } from "@/app/TastierClient";
import { PaymentState } from "@/app/context/PayContext";
import { BaseController } from "@/app/controller/BaseController";
import { UserMenu } from "@/app/ui/UserMenu";

export class PayController_new extends BaseController {
    public onGoBack?: { () };

    private readonly $title: JQuery;
    private readonly $payViewContainer: JQuery;

    public userMenu: UserMenu;

    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();
    static onGoBack = new Signal();
    static onShowSignup = new Signal();

    constructor() {
        super("pay");
        const hdr = $('<div class="head"></div>').appendTo(this.$view);
        this.$title = $('<div class="title"></div>').appendTo(hdr);

        Ripple.bind($('<a class="action left" href="#"><i class="fal fa-arrow-left"></i></a>'))
            .prependTo(hdr)
            .click((e) => {
                e.preventDefault();

                if (
                    TastierClient.payContext.state === PaymentState.Paying ||
                    TastierClient.payContext.state === PaymentState.Failed ||
                    TastierClient.payContext.state === PaymentState.Confirmed
                ) {
                    return;
                }

                this.goBack();
            });

        this.userMenu = new UserMenu().appendTo(hdr);

        this.$payViewContainer = $('<div class="pay-view-container" />').appendTo(this.$view);

        PayController_new.onGoBack.add(this.goBack, this);
        PayController_new.onShowSignup.add(() => {
            this.userMenu.showSignup();
        });

        PayController_new.onInit.dispatch();
    }

    protected onBecomeVisible() {
        PayController_new.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        PayController_new.onHidden.dispatch();
    }

    protected goBack() {
        if (this.onGoBack !== undefined) {
            this.onGoBack();
        }
    }
}
